import Layout from 'components/layout';
import ContentPage from 'components/content-pages';
import { handleContentPageServerSideProps } from 'utils/content-pages';
import { createGetServerSideProps, HandlerType } from 'utils/next/shared-getServerSideProps';
import { EXP_IN_SERVICE_TENANT_ID, EXP_REALTY_US_TENANT_ID } from '@tenants/types';
import { FeaturesType } from 'contexts/features';
import { TenantTypes } from '@tenants';

import type { GetServerSidePropsContext } from 'next';
import type { ContentPageProps } from 'types/content-pages';

const handler: HandlerType<ContentPageProps> = async (_context: GetServerSidePropsContext, _features?: FeaturesType, tenant?: TenantTypes) => {
  return await handleContentPageServerSideProps(tenant.id, [EXP_REALTY_US_TENANT_ID, EXP_IN_SERVICE_TENANT_ID], '/fair-housing-and-reasonable-accommodations');
};

export const getServerSideProps = createGetServerSideProps<ContentPageProps>(handler);

export default function FairHousingAndReasonableAccommodationsPage(props: ContentPageProps) {
  return (
    <Layout>
      <ContentPage {...props} />
    </Layout>
  );
}
